function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Big/OneDrop");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "styleguide",
  transform: "translate(-133.000000, -845.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Big/OneDrop",
  transform: "translate(126.000000, 845.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.2978723,2.58478337 C31.1927943,6.5231423 8.88652482,28.5342764 8.88652482,41.7612888 C8.88652482,56.2948121 20.734844,68.1174193 35.2978723,68.1174193 C49.8609007,68.1174193 61.7092199,56.2948121 61.7092199,41.7612888 C61.7092199,28.5342764 39.4029504,6.5231423 35.2978723,2.58478337 M35.2978723,70 C19.6944255,70 7,57.3321141 7,41.7612888 C7,26.4512008 33.5264255,1.64537557 34.6555106,0.596778098 L35.2978723,0 L35.940234,0.596778098 C37.0693191,1.64537557 63.5957447,26.4512008 63.5957447,41.7612888 C63.5957447,57.3321141 50.9013191,70 35.2978723,70",
  id: "Fill-1"
}))));

var SvgOneDrop = function SvgOneDrop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "70px",
    viewBox: "0 0 57 70",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOneDrop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/one-drop.450837c7.svg";
export { ForwardRef as ReactComponent };